package com.sddamico.components.widgets

import androidx.compose.runtime.Composable
import com.sddamico.SitePalette
import com.sddamico.components.motion.Durations
import com.sddamico.components.motion.Ease
import com.sddamico.components.motion.PressTransition
import com.sddamico.components.motion.PressableStyle
import com.sddamico.components.motion.stableBoldLabel
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@Composable
fun FilterPill(label: String, isActive: Boolean, onClick: () -> Unit) {
    Div(
        PressableStyle.toModifier()
            .backgroundColor(if (isActive) SitePalette.primary else SitePalette.surface)
            .color(if (isActive) Colors.White else SitePalette.textSecondary)
            .border(1.px, LineStyle.Solid, if (isActive) SitePalette.primary else SitePalette.border)
            .borderRadius(9999.px)
            .padding(topBottom = 0.375.cssRem, leftRight = 0.875.cssRem)
            .fontSize(0.8125.cssRem)
            .fontWeight(if (isActive) FontWeight.SemiBold else FontWeight.Medium)
            .cursor(Cursor.Pointer)
            .transition(
                Transition.of("background-color", Durations.HOVER.ms, Ease.Out.fn),
                Transition.of("color", Durations.HOVER.ms, Ease.Out.fn),
                Transition.of("border-color", Durations.HOVER.ms, Ease.Out.fn),
                PressTransition,
            )
            .onClick { onClick() }
            .toAttrs()
    ) {
        SpanText(label, Modifier.stableBoldLabel(label))
    }
}
